module.exports = __webpack_public_path__ + "img/LaFresh.1a1bd1b9.png";